import { atom } from 'jotai'
import { Witness } from '~/types'
import * as z from 'zod'
import {
    aboutYouValidator,
    aboutDriverValidator,
    whatHappenedValidator,
} from '~/lib/zod/bb/motor/theft/validator'

type AboutYou = z.infer<typeof aboutYouValidator>
type AboutDriver = z.infer<typeof aboutDriverValidator>
type WhatHappened = z.infer<typeof whatHappenedValidator>

export const aboutYouAtom = atom<Partial<AboutYou>>({})
export const aboutDriverAtom = atom<Partial<AboutDriver>>({})
export const whatHappenedAtom = atom<Partial<WhatHappened>>({})
export const aboutVehicleAtom = atom({})
export const damageDetailsAtom = atom({})
export const otherDetailsAtom = atom({})

export const witnessAtom = atom<Witness[]>([])

export const allFilesAtom = atom<File[]>([])
export const showDriverSectionAtom = atom(true)
export const retainDriverData = atom<boolean>(false)
